export default __webpack_public_path__ + "static/media/beenius.664d7024.png";